import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { descriptionField, massUnitField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import { purchasedMaterialFields } from './common/productFields';
import { msg } from '@lingui/core/macro';
import { foodFields } from './common/foodFields';

export const foodMassMetadata = {
  displayName: msg({
    message: 'Food mass',
    context: 'Activity data schema name for food mass',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    ...foodFields,
    description: descriptionField,
    quantity: {
      displayName: msg({
        message: 'Food mass',
        context: 'The mass of the food item.',
      }),
      externalDescription: msg({
        message: 'The mass of the food item.',
        context: 'Food mass',
      }),
    },
    unit: massUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
